module.exports = __webpack_public_path__ + "navbar.png";